export default class Environment {
    static get current() {
        return process.env['REACT_APP_ENV'];
    };
}